// extracted by mini-css-extract-plugin
export default {"notification":"YfqUFv93XCYgqf1xXPxw"};